const DITypes = {
  UploadAdapter: Symbol('UploadAdapter'),
  SocketProcessingAdapter: Symbol('SocketProcessingAdapter'),
  UploadDispatcherFactory: Symbol('UploadDispatcherFactory'),
  UploadDispatcher: Symbol('UploadDispatcher'),
};

export default DITypes;
